import { jsxs as d, jsx as l } from "react/jsx-runtime";
import { E as v, S as m } from "./icons.types-0722eef5.js";
function g({ title: n, titleId: h, size: c, width: r, height: s, extended: i = !1, ...e }) {
  const o = i ? v : m, t = c ? o[c] : r || o[i ? "s" : "l"], a = c ? o[c] : s || o[i ? "s" : "l"];
  return /* @__PURE__ */ d(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 72 72",
      width: t,
      height: a,
      "aria-labelledby": h,
      ...e,
      children: [
        n ? /* @__PURE__ */ l("title", { id: h, children: n }) : null,
        /* @__PURE__ */ l("g", { clipPath: "url(#Lock_-_Unlock_svg__a)", children: /* @__PURE__ */ l(
          "path",
          {
            fill: "currentColor",
            fillRule: "evenodd",
            d: "m67.51 1.5 2.99 2.983L4.49 70.33 1.5 67.348 67.51 1.5Zm-9.576 34.511c3.469 1.447 5.243 5.312 4.15 8.888l-.108.324-.12.312-1.073 2.726h4.948v18.67H41.638v-18.67h14.798l1.694-4.26a3.287 3.287 0 0 0-.936-3.772l-.197-.15-.21-.134-.191-.105-.207-.095a3.205 3.205 0 0 0-3.995 1.342l-.113.21-.095.213-.84 2.007-3.719-1.55.837-2.006c1.53-3.725 5.77-5.494 9.47-3.95Zm3.864 16.25h-15.83V62.93h15.83V52.261ZM17.13 1.874c4.044 0 7.376 2.93 7.725 6.727l.023.327.007.318-.002 5.436 4.194.001v18.67H4.984v-18.67l4.59-.001.001-5.436c0-3.57 2.683-6.619 6.214-7.252l.333-.053.338-.037.339-.023.331-.007Zm8.013 16.809H9.313V29.35h15.83V18.683Zm-8.02-12.809-.208.01c-1.502.121-2.942 1.486-3.175 2.941l-.026.22-.008.201-.002 5.436h7.049V9.246c0-1.556-1.46-3.102-3.155-3.339l-.232-.024-.244-.009Z",
            clipRule: "evenodd"
          }
        ) }),
        /* @__PURE__ */ l("defs", { children: /* @__PURE__ */ l("clipPath", { id: "Lock_-_Unlock_svg__a", children: /* @__PURE__ */ l(
          "path",
          {
            fill: "currentColor",
            d: "M0 0h72v72H0z"
          }
        ) }) })
      ]
    }
  );
}
export {
  g as LockUnlock
};
